import {
  CHAT_LOCAL_STORAGE_CHAT_BABY_AGE_KEY,
  CHAT_LOCAL_STORAGE_CHAT_USER,
  CHAT_LOCAL_STORAGE_CONVERSATION_DATA_KEY,
  DEFAULT_AGE,
} from './Chat.values';
import { IConversationItem } from './components/Conversation/@types';
import { IUseChatUserData } from './hooks/useChatUser';

const getChatUser = (): IUseChatUserData =>
  JSON.parse(window.localStorage.getItem(CHAT_LOCAL_STORAGE_CHAT_USER) || '{}');

const isPaymentFlowChat = (): boolean => !!getChatUser()?.paymentToken && !getChatUser().kineduUser;
// getChatUser()?.paymentToken === window.localStorage.getItem(LOCAL_STORAGE_AUTH_TOKEN);

const getCurrentConversation = (chatUserId: string): IConversationItem[] =>
  JSON.parse(window.localStorage.getItem(`${CHAT_LOCAL_STORAGE_CONVERSATION_DATA_KEY}_${chatUserId}`) || '[]') || [];

const saveCurrentConversation = (chatUserId: string, data: IConversationItem[]): void =>
  window.localStorage.setItem(`${CHAT_LOCAL_STORAGE_CONVERSATION_DATA_KEY}_${chatUserId}`, JSON.stringify(data));

const getBabyAge = (): { age: number; isDefault?: boolean } =>
  JSON.parse(window.localStorage.getItem(CHAT_LOCAL_STORAGE_CHAT_BABY_AGE_KEY) || '{}');

const saveBabyAge = (age?: number | string): { age: number; isDefault?: boolean } => {
  const numers = `${age}`.replace(/[^0-9]/g, '').slice(0, 2);
  const isDefault = !numers;
  const ageValues = {
    age: isDefault ? DEFAULT_AGE : +numers,
    isDefault,
  };
  window.localStorage.setItem(CHAT_LOCAL_STORAGE_CHAT_BABY_AGE_KEY, JSON.stringify(ageValues));

  return ageValues;
};
const clearChatSession = (): void => {
  [CHAT_LOCAL_STORAGE_CHAT_BABY_AGE_KEY, CHAT_LOCAL_STORAGE_CHAT_USER, CHAT_LOCAL_STORAGE_CONVERSATION_DATA_KEY].map(
    (item) => window.localStorage.removeItem(item),
  );
};

export {
  getChatUser,
  getCurrentConversation,
  saveCurrentConversation,
  getBabyAge,
  saveBabyAge,
  clearChatSession,
  isPaymentFlowChat,
};
